import { BaseDayAttendanceType, LabelMapper } from 'types';
import { journalTexts } from 'consts/text';

export const baseDayAttendanceTypesLabels: LabelMapper<BaseDayAttendanceType> = {
    ABSENT: journalTexts.journalDetails.specialJournal.attendance.absent,
    PRESENT: journalTexts.journalDetails.specialJournal.attendance.present,
};
